import { render, staticRenderFns } from "./BaseStatus.vue?vue&type=template&id=bd6d5510"
import script from "./BaseStatus.vue?vue&type=script&lang=js"
export * from "./BaseStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports